/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateDeliveryAddressInBillingTabMutationVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
  customerDetails: GraphQL.Scalars['Array']['input'];
}>;


export type UpdateDeliveryAddressInBillingTabMutation = { readonly __typename?: 'Mutation', readonly StoreCustomerDetails: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly billingDetails: { readonly __typename?: 'AccountBillingDetails', readonly deliveryAddress: { readonly __typename?: 'BillingDetailsAddress', readonly address: string, readonly city: string, readonly country: string, readonly name: string, readonly postalCode: string, readonly state: string | null } | null } | null } | null } } };


export const UpdateDeliveryAddressInBillingTabDocument = gql`
    mutation UpdateDeliveryAddressInBillingTab($accountId: AccountId!, $customerDetails: Array!) {
  StoreCustomerDetails(accountId: $accountId, customerDetails: $customerDetails) {
    query {
      account(id: $accountId) {
        id
        billingDetails {
          deliveryAddress {
            address
            city
            country
            name
            postalCode
            state
          }
        }
      }
    }
  }
}
    `;
export type UpdateDeliveryAddressInBillingTabMutationFn = Apollo.MutationFunction<UpdateDeliveryAddressInBillingTabMutation, UpdateDeliveryAddressInBillingTabMutationVariables>;

/**
 * __useUpdateDeliveryAddressInBillingTabMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryAddressInBillingTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryAddressInBillingTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryAddressInBillingTabMutation, { data, loading, error }] = useUpdateDeliveryAddressInBillingTabMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      customerDetails: // value for 'customerDetails'
 *   },
 * });
 */
export function useUpdateDeliveryAddressInBillingTabMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryAddressInBillingTabMutation, UpdateDeliveryAddressInBillingTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryAddressInBillingTabMutation, UpdateDeliveryAddressInBillingTabMutationVariables>(UpdateDeliveryAddressInBillingTabDocument, options);
      }
export type UpdateDeliveryAddressInBillingTabMutationHookResult = ReturnType<typeof useUpdateDeliveryAddressInBillingTabMutation>;
export type UpdateDeliveryAddressInBillingTabMutationResult = Apollo.MutationResult<UpdateDeliveryAddressInBillingTabMutation>;
export type UpdateDeliveryAddressInBillingTabMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryAddressInBillingTabMutation, UpdateDeliveryAddressInBillingTabMutationVariables>;